module.exports = __webpack_public_path__ + "static/impulse@2x-33e13c91ac5653eb6eb33c8763e918f0.png";